import { render, staticRenderFns } from "./mainLayout.vue?vue&type=template&id=548354a2&scoped=true"
import script from "./mainLayout.vue?vue&type=script&lang=js"
export * from "./mainLayout.vue?vue&type=script&lang=js"
import style0 from "./mainLayout.vue?vue&type=style&index=0&id=548354a2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548354a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('548354a2')) {
      api.createRecord('548354a2', component.options)
    } else {
      api.reload('548354a2', component.options)
    }
    module.hot.accept("./mainLayout.vue?vue&type=template&id=548354a2&scoped=true", function () {
      api.rerender('548354a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/mainLayout.vue"
export default component.exports